module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/332.2c705b5e.png";